import RequestWarningModal from "@/modals/RequestWarningModal";
export default {
  methods: {
    /**
     * Модалка с сообщением об ошибке
     * @param {object} options
     * @param {array=} requests - Заявки
     * @param {function} confirmHandler
     */
    showRequestWarningModal({ requests, confirmHandler }) {
      this.$modal.show(
        RequestWarningModal,
        {
          requests,
          confirmHandler,
        },
        {
          adaptive: true,
          scrollable: true,
          height: "auto",
          clickToClose: false,
          width: 800,
        }
      );
    },
  },
};
